import history from '../providers/HistoryProvider';

export function pushPathToHistory(path) {
    history.push(path);
}




// WEBPACK FOOTER //
// ./src/actions/History.js